<section>
  <div class="banner-publicidad" *ngIf="bannerPublidiadData?.visible && isFordPath">
    <div *ngIf="bannerPublidiadData.link.includes('http') else imageOnly">
      <a [href]="bannerPublidiadData.link" target="_blank" rel="noopener noreferrer">
        <img [src]="basepath+bannerPublidiadData.image[0].url" alt="Banner Publicidad" class="image_banner__publicidad" />
      </a>
    </div>
    <ng-template #imageOnly>
      <img [src]="basepath+bannerPublidiadData.image[0].url" alt="Banner Publicidad" class="image_banner__publicidad" />
    </ng-template>
  </div>
</section>